import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  AERIALS_TAGS,
  CASES_TAGS,
  CHAT_TAGS,
  ORG_STRUCTURE_TAGS,
  PROJECTS_TAGS,
  TOOLKIT_TAGS,
  USERS_TAGS,
} from '@/api/constants';
// Internal import to avoid circular dependency with @/api
import { navigateMiddleware } from './navigationMiddleware';
import { enhanceBaseQuery } from './enhanceBaseQuery';
import { AppRoutes } from '@/constants';

const baseUrl = `${import.meta.env.VITE_FLETCH_API_URL}/fletch/`;

const baseQuery = fetchBaseQuery({
  baseUrl,
  credentials: 'include',
  prepareHeaders: (headers) => {
    headers.set('fletch-api-key', `${import.meta.env.VITE_FLETCH_API_KEY}`);
    return headers;
  },
});

const baseQueryWithRetryAndRedirect = enhanceBaseQuery({
  baseQuery,
  onUnauthorized: () => navigateMiddleware(`/${AppRoutes.Login}`),
});

/** Base API. Import endpoints from the files that inject them, so their types are available. */
export const api = createApi({
  baseQuery: baseQueryWithRetryAndRedirect,
  tagTypes: [
    ...USERS_TAGS,
    ...CHAT_TAGS,
    ...CASES_TAGS,
    ...PROJECTS_TAGS,
    ...AERIALS_TAGS,
    ...ORG_STRUCTURE_TAGS,
    ...TOOLKIT_TAGS,
  ],
  endpoints: () => ({}),
});
